/* app/js/src/components/common/_dropdown/dropdown.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host ul::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
:host ul::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
:host ul::-webkit-scrollbar-corner {
  background: transparent;
}
:host ul::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
:host ul::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
:host ul::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
:host ul::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
:host ul::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
:host {
  position: relative;
  display: inline-block;
  width: 200px;
}
:host.short {
  width: 80px;
}
:host.medium {
  width: 100px;
}
:host.large {
  width: 100%;
}
:host.large div span {
  width: 100%;
}
:host.multiple-size {
  padding: 0;
  margin: 0;
  height: min-content !important;
  display: flex !important;
  flex-grow: 1 !important;
}
:host .selected-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 98%;
  height: 100%;
  line-height: 30px;
  color: #232f3a;
  cursor: pointer;
}
:host .selected-container .selected {
  display: inline-block;
  width: 98%;
  font-style: normal;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
:host .selected-container .selected.placeholder {
  color: #c9cdd6;
}
:host .selected-container svg {
  display: block;
}
:host ul {
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 9;
  max-height: 40vh;
  overflow: auto;
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  list-style-type: none;
  padding: 0;
  margin: 0;
  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
}
:host ul.defaultOptionWidth {
  width: 227px;
}
:host ul.dropdown-list {
  bottom: auto !important;
  top: 29px;
}
:host ul ng-content {
  width: 100%;
}
:host.top ul {
  bottom: 0;
}
:host.bottom ul {
  top: 100%;
  -webkit-box-shadow: 0 7px 5px 2px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 7px 5px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 7px 5px 2px rgba(0, 0, 0, 0.2);
}
.multiple-item-label {
  padding: 3px;
  margin: 2px;
  background-color: #f1f3f4;
  border-radius: 4px;
  line-height: 11px;
  display: flex;
  font-family: OpenSans;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #232f3a;
}
.selected-multiple {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.settingIcon {
  cursor: pointer;
  margin-right: 5px;
  margin-top: 3px;
}
.settingIcon ::ng-deep svg {
  width: 13px;
  height: 13px;
}
.settingIcon ::ng-deep svg path {
  fill: #879baf !important;
}
.text-align-left {
  text-align: left !important;
}
.settingIconSubs ::ng-deep svg path {
  fill: #40c4ff !important;
}
.width165 {
  width: 165px !important;
}
.color-white {
  color: white !important;
}
.main-container {
  width: 100%;
  height: 100%;
}
.select-all-option {
  background-color: red;
}
/*# sourceMappingURL=dropdown.component.css.map */
